import History from '@jupiterone/react-brand-icons/jupiterone/clock-rewind';
import { MenuItem } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import EditIcon from 'react-feather/dist/icons/edit-2';
import LinkIcon from 'react-feather/dist/icons/external-link';
import TrashIcon from 'react-feather/dist/icons/trash';
import MeshIcon from '../../../../icons/Mesh';
import { JupiterTheme } from '../../../../theme/types';
import SafeURL from '../../../SafeURL';
import useEntityDrawer from '../useEntityDrawer';
import { openInGraphQuery } from '../utils/openInGraphQuery';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    headerTitleClose: {
      color: theme.palette.blue[100],
      width: 24,
      height: 24,
      fontSize: 24,
      margin: 6,
      cursor: 'pointer',
      '&:hover': {
        color: theme.palette.common.white,
      },
    },
    listMenu: {
      marginTop: theme.spacing(7),
      marginRight: 0,
      marginLeft: -theme.spacing(3),
      minWidth: 120,
    },
    menuItem: {
      paddingRight: theme.spacing(3.25),
      paddingLeft: theme.spacing(3.25),
      '& b': {
        color: theme.palette.coolGrey[400],
        transition: 'color 0.3s',
      },
      '&:hover': {
        backgroundColor: theme.palette.coolGrey[50],
        '& b': {
          color: theme.palette.primary.main,
        },
      },
    },
    menuIcon: {
      color: theme.palette.primary.dark,
      marginRight: theme.spacing(1.25),
      transition: 'color 0.3s',
      ':hover > &': {
        color: theme.palette.primary.dark,
      },
    },
    webLink: {
      '& a, & div': {
        color: 'inherit',
        textDecoration: 'none',
        display: 'flex',
      },
    },
    graphIcon: {
      strokeWidth: 2,
    },
  })
);

export const EntityMenuItems = () => {
  const classes = useStyles();
  const {
    entity: { entity },
    editModal,
    deleteModal,
    rawDataModal,
  } = useEntityDrawer();

  if (!entity) return null;

  const openInGraph = () => {
    window.open(
      `/landing?query=${encodeURIComponent(openInGraphQuery(entity._key))}`
    );
  };

  const promptWrapper = (fn: (is: boolean) => void, is: boolean) => () =>
    fn(is);

  return (
    <>
      <MenuItem
        onClick={() => rawDataModal.open()}
        className={classes.menuItem}
      >
        <History className={classes.menuIcon} />
        History
      </MenuItem>
      {editModal && (
        <MenuItem
          aria-label="edit"
          onClick={promptWrapper(editModal.open, entity.isIntegrationEntity)}
          className={classes.menuItem}
        >
          <EditIcon className={classes.menuIcon} />
          Edit
        </MenuItem>
      )}
      {deleteModal && (
        <MenuItem
          aria-label="delete"
          onClick={promptWrapper(deleteModal.open, entity.isIntegrationEntity)}
          className={classes.menuItem}
        >
          <TrashIcon className={classes.menuIcon} />
          Delete
        </MenuItem>
      )}
      {entity.webLink && (
        <MenuItem className={clsx(classes.menuItem, classes.webLink)}>
          <LinkIcon className={classes.menuIcon} />
          <SafeURL url={entity.webLink} displayText={'Web Link'} />
        </MenuItem>
      )}
      {entity.isShodanLink && (
        <MenuItem className={clsx(classes.menuItem, classes.webLink)}>
          <LinkIcon className={classes.menuIcon} />
          <SafeURL
            url={`https://www.shodan.io/host/${entity.publicIpAddress}`}
            displayText={'Shodan Link'}
          />
        </MenuItem>
      )}
      <MenuItem
        aria-label="Open Graph"
        className={clsx(classes.menuItem, classes.webLink)}
        onClick={openInGraph}
      >
        <MeshIcon className={clsx(classes.menuIcon, classes.graphIcon)} />
        Open in Graph
      </MenuItem>
    </>
  );
};
export default EntityMenuItems;
